import type { PageCard } from '@/play/pageTypes'
import { VanishingTrailCardArt } from './CardArt'

/** What the home screen shows for this page; the page itself is ./index.ts, loaded when it opens. */
export const card: PageCard = {
  id: 'vanishing-trail',
  number: 24,
  title: 'Vanishing trail',
  question: 'Does a trail of another material that fades behind the brush make drawing more fun?',
  status: 'open',
  accent: '#d6e6cc',
  CardArt: VanishingTrailCardArt,
}
